import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'sphere', 'Sphere', [["path",{"d":"M3 12c0 1.657 4.03 3 9 3s9 -1.343 9 -3"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}]]);